import useAuth from "hooks/useAuth";
import React from "react";
import UserProfile from "components/UserProfile";
import NavBarSearch from "components/NavBarSearch";

const NavBarTop = () => {
  const { username, user_id, first_name, last_name, email } = useAuth();

  return (
    <nav className="navbar-top">
      <div className="container">
        <div className="search-container">
          <NavBarSearch />
        </div>
        <div className="profile-container">
          <UserProfile
            name={username}
            userId={user_id}
            firstName={first_name}
            lastName={last_name}
            email={email}
          />
        </div>
      </div>
    </nav>
  );
};

export default NavBarTop;
